import { ErrorHandler, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AlertActions from './+state/alert.actions';
import { AlertState } from './+state/alert.reducer';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private store: Store<AlertState>) {}
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      this.store.dispatch(
        AlertActions.displayAlert({
          title: 'Error loading website',
          body: '<p>There appears to have been an error loading the page. Some of the functionality my be missing.</p><p>Please refresh the page</p>',
          level: 'warning',
          noTimeout: true,
        }),
      );
    }
  }
}
